module.exports = __webpack_public_path__ + "img/dsz.a7abc22a.png";